var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"swiper-image-text",staticStyle:{"margin-left":"15px"}},[_c('div',{staticClass:"_6xlfkc2msys",staticStyle:{"width":"270px","height":"180px"}})])])
}]

export { render, staticRenderFns }